var _a, _b;
import { __assign } from "tslib";
import { reduxKey } from './constants';
import { submitStatus, submitStatusSuccess, submitStatusFailure, submitStatusFailureDismiss, } from './actions';
var defaultState = {
    isSubmitting: false,
    statusId: null,
    error: null,
};
// submitStatusSuccess is fired by the saga just before redirecting to the
// status' canonical page. While the browser is loading, the reducer for that
// action keeps the submit button disabled by artifically continuing the
// appearance that it's still submitting.
//
// If redirection UX changes, keep in mind the isSubmitting flag.
var actionHandlers = (_a = {},
    _a[submitStatus.toString()] = function (state, action) { return (__assign(__assign({}, state), { isSubmitting: true, error: null })); },
    _a[submitStatusSuccess.toString()] = function (state, action) { return (__assign(__assign({}, state), { isSubmitting: true, statusId: action.payload.statusId, error: null })); },
    _a[submitStatusFailure.toString()] = function (state, action) { return (__assign(__assign({}, state), { isSubmitting: false, error: action.payload.error })); },
    _a[submitStatusFailureDismiss.toString()] = function (state, action) { return (__assign(__assign({}, state), { error: null })); },
    _a);
var reducers = (_b = {},
    _b[reduxKey] = function (state, action) {
        if (state === void 0) { state = defaultState; }
        if (!actionHandlers[action.type]) {
            return state;
        }
        return actionHandlers[action.type](state, action) || state;
    },
    _b);
export default reducers;
//# sourceMappingURL=reducers.js.map